import { Skeleton } from '@/components/ui/skeleton';

interface FormSkeletonProps {
  fields?: ('text' | 'textarea' | 'editor' | 'file' | 'checkbox')[];
  showGenerateButton?: boolean;
  showTable?: boolean;
}

export const FormSkeleton = ({
  fields = ['editor', 'checkbox'],
  showGenerateButton = false,
  showTable = false,
}: FormSkeletonProps) => (
  <section className="w-full">
    <div className="flex flex-col gap-3 px-5 pt-5 pb-3">
      <div className="flex justify-between items-start">
        <div className="space-y-2 flex-1">
          <Skeleton className="h-8 w-64" />
          <Skeleton className="h-4 w-96" />
        </div>
        <div className="flex gap-3">
          {showGenerateButton && <Skeleton className="h-10 w-40" />}
          <Skeleton className="h-10 w-32" />
        </div>
      </div>
    </div>

    <div className="mx-5 border-b border-gray-200" />

    <div className="pt-5 px-5 space-y-6">
      {fields.map((type, idx) => {
        switch (type) {
          case 'text':
            return (
              <div key={idx} className="space-y-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-10 w-full rounded-md" />
              </div>
            );
          case 'textarea':
            return (
              <div key={idx} className="space-y-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-32 w-full rounded-md" />
              </div>
            );
          case 'editor':
            return (
              <div key={idx} className="space-y-2">
                <Skeleton className="h-5 w-40" />
                <Skeleton className="h-64 w-full rounded-md" />
              </div>
            );
          case 'file':
            return (
              <div key={idx} className="space-y-2">
                <Skeleton className="h-5 w-32" />
                <Skeleton className="h-40 w-full rounded-md border-2 border-dashed" />
              </div>
            );
          case 'checkbox':
            return (
              <div key={idx} className="flex items-center space-x-2">
                <Skeleton className="h-5 w-5 rounded" />
                <Skeleton className="h-5 w-48" />
              </div>
            );
          default:
            return null;
        }
      })}

      {/* Table for BusinessGoal */}
      {showTable && (
        <div className="space-y-4 pt-6">
          <div className="flex justify-between items-center">
            <Skeleton className="h-6 w-40" />
            <Skeleton className="h-10 w-32" />
          </div>
          <div className="space-y-2">
            <Skeleton className="h-12 w-full rounded-md" />
            <Skeleton className="h-16 w-full rounded-md" />
            <Skeleton className="h-16 w-full rounded-md" />
            <Skeleton className="h-16 w-full rounded-md" />
          </div>
        </div>
      )}
    </div>
  </section>
);

export const PurposeSkeleton = () => <FormSkeleton fields={['editor', 'checkbox']} showGenerateButton />;
export const VisionSkeleton = () => <FormSkeleton fields={['editor', 'checkbox']} showGenerateButton />;
export const MissionSkeleton = () => (
  <FormSkeleton fields={['editor', 'editor', 'editor', 'editor', 'checkbox']} showGenerateButton />
);
export const CultureSkeleton = () => <FormSkeleton fields={['editor', 'checkbox']} showGenerateButton />;
export const PositioningSkeleton = () => (
  <FormSkeleton fields={['editor', 'editor', 'editor', 'editor', 'editor', 'checkbox']} showGenerateButton />
);
export const BusinessGoalSkeleton = () => <FormSkeleton fields={[]} showTable showGenerateButton />;
